module.exports = __webpack_public_path__ + "img/icon-ekg-inactive.a96515d8.png";